import { ref } from "vue";
import { useUserStore } from "@/stores/user";

// Versão da app definida no .env (VITE_APP_VERSION, equivalente ao LOG_APP_VERSION do zslic-be)
const appVersion = import.meta.env.VITE_APP_VERSION || "0.0";

// Commit embutido no build pelo vite.config.js (trim: o execSync traz um \n no fim)
const appHash = _APP_COMMIT_HASH_.trim();

// Estado partilhado (singleton) — o fetch ao BE é feito uma vez e reutilizado
// por todos os componentes que mostram a versão (login, sidenav, ...).
const serverVersion = ref({
  hash: "",
  app: "",
});
let fetched = false;

export function useAppVersion() {
  const userStore = useUserStore();

  const fetchServerVersion = async (force = false) => {
    if (fetched && !force) return;
    fetched = true;

    try {
      const res = await userStore.getServerVersion();
      serverVersion.value.hash = (res?.data[0] ?? "").substring(0, 7);
      // Versão da app do BE (LOG_APP_VERSION); vazio se o BE ainda não expuser a chave.
      serverVersion.value.app = res?.app_version ?? "";
    } catch (err) {
      console.log(err);
    }
  };

  return { appVersion, appHash, serverVersion, fetchServerVersion };
}
